export class ConfirmEmail {
  Email: string;
  Code: string;
  Password: string;

  constructor() {
    this.Email = null;
    this.Password = null;
    this.Code = null;
  }
}
